module.exports = __webpack_public_path__ + "media/images/weather/64_day_g-2adac2a5bb8b23f835838db3b091968d.png";